import axios from "axios";
import Facility from "../../modules/Facilities";
import { API_BASE_URL } from "../../config/constants/endpoints";

const FacilityPage = () => {
  return <Facility />;
};

export const getStaticProps = async () => {
  let result;
  try {
    const { data } = await axios.get<FacilityResponse>(
      "/v1/facility?is_enable_booking=true",
      {
        baseURL: API_BASE_URL,
      }
    );
    result = data;
  } catch (error) {
    console.log("errorna", error);
  }

  console.log("datass", result);
  return {
    props: {
      fallback: {
        [`/v1/facility?is_enable_booking=true`]: result,
      },
    },
    revalidate: 300, // 5 minutes
  };
};

export default FacilityPage;
